 <template>
  <!--
    Purpose of this component is to init subscription data if not done yet
    before entering Subscription.
  -->
  <section>
    <Subscription></Subscription>
  </section>
</template>

<script>
import doRequest from '@/api/dssRequest';
import Subscription from '@/components/subscription/Subscription';

export default {
  name: 'PartnerGroupSubscription',
  components: {
    Subscription,
  },
  mounted() {
    this.init();
  },
  computed: {
    getUserId() {
      return this.$store.getters['auth/userName'];
    }
  },
  methods: {
    init() {
      this.$store.commit('subscription/clear');
      this.getSubscriptionProducts();
      // this.getPartnerGroup();
      //
      // if (this.partnerGroupDetails != null
      //   && this.partnerGroupDetails.Suggestions != null
      //   && this.partnerGroupDetails.Suggestions.Products != null
      // ) {
      //   this.$store.commit('subscription/setAllProducts', this.partnerGroupDetails.Suggestions.Products);
      // }
    },
    getPartnerGroup() {
      const payload = {
        Url: this.$store.getters.getPartnerGroupUrl,
      };

      doRequest(
        (response) => {
          if (response.data.Suggestions != null
            && response.data.Suggestions.Products != null
          ) {
            this.$store.commit('subscription/setAllProducts', response.data.Suggestions.Products);
          }
        },
        () => {},
        'getPartnerGroup',
        'LocationsNode_PGSE',
        payload,
        'GET',
      );
    },

    getSubscriptionProducts() {
      const payload = {
        UseGenericResponse: false,
      };

      doRequest(
        (response) => {
          if (response.data != null
            && response.data.Products != null
          ) {
            this.$store.commit('subscription/setAllProducts', []);
            this.$store.commit('subscription/setAllProducts', response.data.Products);
          }
        },
        () => {},
        'getSubscriptionProducts',
        this.getUserId,
        payload,
        'GET',
      );
    }
  },
};
</script>
